import dayjs from "dayjs";
const parseDateValue = (initDate) => {
  if (!initDate) return null;
  if (initDate instanceof Date) {
    return Number.isNaN(initDate.getTime()) ? null : initDate;
  }
  // [yyyy, m, d] / [yyyy, m, d, h, m, s]
  if (Array.isArray(initDate)) {
    const [year, month, day, hour = 0, minute = 0, second = 0] = initDate;
    if (!year || !month || !day) return null;
    const date = new Date(year, month - 1, day, hour, minute, second);
    return Number.isNaN(date.getTime()) ? null : date;
  }
  const date = new Date(initDate);
  return Number.isNaN(date.getTime()) ? null : date;
};

const getDateInfo = (dateValue) => {
  const mm = String(dateValue.getMonth() + 1).padStart(2, "0");
  const dd = String(dateValue.getDate()).padStart(2, "0");
  const yyyy = dateValue.getFullYear();
  const hh = String(dateValue.getHours()).padStart(2, "0");
  const min = String(dateValue.getMinutes()).padStart(2, "0");
  const ss = String(dateValue.getSeconds()).padStart(2, "0");
  return {
    mm,
    dd,
    yyyy,
    hh,
    min,
    ss,
  };
};

const dataTo12Fn = (initDate, type = 1) => {
  const tempDate = parseDateValue(initDate);
  if (!tempDate) {
    return "";
  }
  const { mm, dd, yyyy, hh, min } = getDateInfo(tempDate);
  const typeEnum = {
    1: `${mm}/${dd}/${yyyy} ${hh >= 12 ? hh - 12 : hh}:${min} ${hh >= 12 ? "PM" : "AM"}`,
    2: `${mm}/${dd}/${yyyy}`,
    3: `${hh >= 12 ? hh - 12 : hh}:${min} ${hh >= 12 ? "PM" : "AM"}`,
  };
  return typeEnum[type] || "";
};

const formatDateText = (date, emptyText = "-") => {
  if (!date) return emptyText;

  if (typeof date === "string") {
    const parts = date.split("-");
    if (parts.length !== 3) return date || emptyText;
    return `${parts[1]}/${parts[2]}/${parts[0]}`;
  }

  const tempDate = parseDateValue(date);
  if (!tempDate) return emptyText;
  const { mm, dd, yyyy } = getDateInfo(tempDate);
  return `${mm}/${dd}/${yyyy}`;
};

const formatHm = (obj = {}) => {
  const hours = Number(obj?.hours) || 0;
  const minutes = Number(obj?.minutes) || 0;
  return `${hours} Hrs; ${minutes} Min`;
};


/**
 * 将后端数组格式转换为 dayjs 对象
 * @param {Array} dateArray - [year, month, day] 格式的数组
 * @returns {dayjs|null} dayjs对象或null
 */
const convertArrayToDayjs = (dateArray) => {
  if (!dateArray || !Array.isArray(dateArray)) return null;
  return dayjs()
    .year(dateArray[0])
    .month(dateArray[1] - 1)
    .date(dateArray[2]);
};
export { dataTo12Fn, formatDateText, formatHm,convertArrayToDayjs, };
